import React, { Component } from "react";
import Layout from "../../../Layout/layout";
import Helmet from "react-helmet";
import "../../../styles/reports/reports.scss";
import axios from "axios";
import {
  setLoadingPage,
  setErrorMessage,
  setHeaderVisible,
} from "../../../reducers/actions";
import { connect } from "react-redux";
import { apiHost } from "../../../api/apiClient";
import moment from "moment";
import {
  Button,
} from "react-bootstrap";
import GridLoader from "react-spinners/GridLoader";
import Calendar from "react-calendar/dist/umd/Calendar";
import TotalSummary from "../groupRunningSummary/totalSummary";
import GroupSummaryMetricTiles from "../groupRunningSummary/metricTiles";
import AssetInforWarning from "../../commoncomponents/assetInforWarning";
import TimeZoneConvert from "../../../utils/timeZoneConvert";
import ReportButtonGroup from "../../commoncomponents/reportButtonGroup";
import Select from "react-select";

class GroupRunningSummary extends Component {
  constructor(props) {
    super(props);
    this.state = {
      assetPlaceholder: "Select Asset",
      dataPlaceholder: "Select start date",
      dataPlaceholder2: "Select end date",
      assetShow: false,
      globalDate: "",
      groupTabHighlight: true,
      assetTabHighlight: false,
      groupTabHeading: true,
      assetTabHeading: true,
      groupCustomerName: "",
      groupGeneralName: "",
      assetCustomerName: "",
      assetGeneralName: "",
      calendarSelect: false,
      calendarSelect2: false,
      ReportDate: new Date(),
      calendarStartDate: new Date(),
      calendarEndDate: new Date(),
      calendarShow: false,
      calendarShow2: false,
      endDate: "",
      groupDetails: [],
      groupId: "",
      AssetList: [],
      assetIdArray: [],
      assetId: "",
      reportDetails: [],
      assetLoader: true,
      reportLoader: false,
      errorLoader: false,
      generatedDate: moment().format("DD-MM-YYYY hh:mm a"),
      assetSelectionBoolean: false,
      groupName: "",
      customerName: "",
      timeZone: localStorage.getItem("timeZone"),
      loadedReportParams: null,
    };
    this.setWrapperRef = this.setWrapperRef.bind(this);
    this.handleClickOutside = this.handleClickOutside.bind(this);
    this.maxDate = moment().subtract(1, 'days').toDate();
  }
  async componentDidMount() {
    try {
      let GroupList = await axios.post(
        `${apiHost}/api/Notification/AllGroupForNotification`,
        {},
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        }
      );

      this.setState({ groupDetails: GroupList.data });
    } catch (e) {
      console.log(`😱 Axios request failed: ${e}`);
    }
    document.addEventListener("mousedown", this.handleClickOutside);
  }

  componentWillUnmount() {
    document.removeEventListener("mousedown", this.handleClickOutside);
  }

  /**
   * Set the wrapper ref
   */
  setWrapperRef(node) {
    this.wrapperRef = node;
  }

  /**
   * Alert if clicked on outside of element
   */
  handleClickOutside(event) {
    if (this.wrapperRef && !this.wrapperRef.contains(event.target)) {
      this.setState({ calendarShow: false, calendarShow2: false });
    }
  }

  handleGroupDropDown = (groupid, groupname, customername) => {
    this.setState({
      groupId: groupid,
      groupName: groupname,
      customerName: customername,
    });

    this.getAssets(groupid);
  };
  getAssets = async (groupid) => {
    try {
      let AssetList = await axios.get(
        `${apiHost}/api/Notification/AssetsByGroupId/${groupid}?IsReport=true`,
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        }
      );

      this.setState({
        AssetList: AssetList.data.paggedlist,
        assetLoader: false,
      });

      let assetIdArray = AssetList.data.includedelements;
      this.setState({ assetIdArray: assetIdArray });
    } catch (e) {
      console.log(`😱 Axios request failed: ${e}`);
    }
  };

  handleGroupSelection = (customer, name, id) => {
    this.setState({ assetLoader: true });
    this.groupId = id;
    this.setState({
      groupId: id,
      groupCustomerName: customer,
      groupGeneralName: name,
      assetCustomerName: "",
      assetGeneralName: "",
      assetTabHeading: true,
      groupTabHighlight: false,
      assetTabHighlight: true,
      groupTabHeading: false,
    });
    this.getAssets();
  };
  handleAssetSelection = (asset, name, id) => {
    this.setState({
      assetId: id,
      assetCustomerName: asset,
      assetGeneralName: name,
      // groupTabHighlight:false,
      assetTabHighlight: false,
      assetTabHeading: false,
    });
  };
  toggleGroupTable = () => {
    let assetClosingBoolean = !this.state.groupTabHighlight;
    this.setState({
      groupTabHighlight: !this.state.groupTabHighlight,
    });

    if (assetClosingBoolean) {
      this.setState({
        assetTabHighlight: false,
      });
    }
  };
  toggleAssetTable = () => {
    let groupClosingBoolean = !this.state.assetTabHighlight;

    this.setState({
      assetTabHighlight: !this.state.assetTabHighlight,
    });
    if (groupClosingBoolean) {
      this.setState({
        groupTabHighlight: false,
      });
    }
  };
  truckFunction = () => {
    // alert("truck function clicked");
    this.setState({
      assetShow: !this.state.assetShow,
    });
  };
  calendarFunction = () => {
    this.setState({
      calendarShow: !this.state.calendarShow,
    });
  };
  onChangeDate = (date) => {
    this.setState({
      calendarSelect: true,
      calendarStartDate: date,
      globalDate: date,
      ReportDate: moment(date).format("YYYY-MM-DD"),
      dataPlaceholder: moment(date).format("dddd Do MMMM, YYYY"),
      calendarShow: false,
    });
  };
  calendarFunction2 = () => {
    if (this.state.globalDate != "") {
      this.setState({
        calendarShow2: !this.state.calendarShow2,
      });
    } else {
      alert("select start date");
    }
  };
  onChangeDate2 = (date) => {
    this.setState({
      calendarSelect2: true,
      calendarEndDate: date,
      endDate: moment(date).format("YYYY-MM-DD"),
      dataPlaceholder2: moment(date).format("dddd Do MMMM, YYYY"),
      calendarShow2: false,
    });
  };
  handleWindow = () => {
    this.props.setHeaderVisibleAction(!this.props.headerHide);
  };
  handleCreateReport = async () => {
    this.setState({
      assetSelectionBoolean: true,
      reportLoader: true,
      generatedDate: moment().format("DD-MM-YYYY hh:mm a"),
      loadedReportParams: {
        groupId: this.state.groupId,
        assetIds: this.state.assetIdArray.join(","),
        reportDate: this.state.ReportDate,
        endDate: this.state.endDate,
      },
    });

    try {
      let ReportDetails = await axios.post(
        `${apiHost}/api/Report/GroupRunningSummary`,
        {
          AssetIds: this.state.assetIdArray,
          SearchDate: this.state.ReportDate,
          Timezone: localStorage.getItem("timeZoneID"),
          EndDate: this.state.endDate,
          UseFiltering: true,
        },
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        }
      );
      this.setState({
        reportLoader: false,
        errorLoader: false,
      });

      this.setState({ reportDetails: ReportDetails.data });
    } catch (e) {
      this.setState({ errorLoader: true, reportLoader: false });
      console.log(`😱 Axios request failed: ${e}`);
    }
  };

  render() {
    const selectStyles = {
      control: (base, state) => ({
        ...base,
        minHeight: 42,
        borderColor: state.isFocused ? "#244b8f" : "#dbe4ef",
        borderRadius: 8,
        boxShadow: state.isFocused ? "0 0 0 3px rgba(36, 75, 143, .12)" : "none",
        backgroundColor: "#f8fafc",
        "&:hover": {
          borderColor: "#aebdd0",
        },
      }),
      placeholder: (base) => ({
        ...base,
        color: "#6f7f95",
        fontWeight: 700,
      }),
      singleValue: (base) => ({
        ...base,
        color: "#17233c",
        fontWeight: 700,
      }),
      menu: (base) => ({
        ...base,
        zIndex: 200,
        borderRadius: 8,
        overflow: "hidden",
      }),
    };

    const groupOptions = this.state.groupDetails.map((group) => ({
      value: group.groupId,
      label: `${group.customername} - ${group.groupName}`,
      data: group,
    }));

    const selectedGroupOption =
      groupOptions.find((option) => option.value == this.state.groupId) ||
      (this.state.groupId
        ? {
            value: this.state.groupId,
            label: `${this.state.groupName} - ${this.state.customerName}`,
          }
        : null);
    const canCreateReport = !!(
      this.state.customerName != "" &&
      this.state.calendarSelect &&
      this.state.calendarSelect2
    );
    const loadedReportParams = this.state.loadedReportParams;
    const hasPendingReportChanges = !!(
      loadedReportParams &&
      canCreateReport &&
      (
        loadedReportParams.groupId !== this.state.groupId ||
        loadedReportParams.assetIds !== this.state.assetIdArray.join(",") ||
        loadedReportParams.reportDate !== this.state.ReportDate ||
        loadedReportParams.endDate !== this.state.endDate
      )
    );

    const calendarReport = this.state.calendarShow ? (
      <div
        ref={this.setWrapperRef}
        className="ParentCalender"
        style={{ position: "relative", zIndex: 100 }}
      >
        <div className="CalendarContainer" style={{ position: "absolute" }}>
          <Calendar
            maxDate={this.maxDate}
            onChange={this.onChangeDate}
            value={this.state.calendarStartDate}
          />
        </div>
      </div>
    ) : (
      ""
    );

    const calendarReport2 = this.state.calendarShow2 ? (
      <div
        className="ParentCalender"
        ref={this.setWrapperRef}
        style={{ position: "relative", zIndex: 100 }}
      >
        <div className="CalendarContainer" style={{ position: "absolute" }}>
          <Calendar
            minDate={this.state.globalDate}
            maxDate={
              moment(this.state.globalDate).add(3, "months").toDate() >
              this.maxDate
                ? this.maxDate
                : moment(this.state.globalDate).add(3, "months").toDate()
            }
            onChange={this.onChangeDate2}
            value={this.state.calendarEndDate}
          />
        </div>
      </div>
    ) : (
      ""
    );
    return (
      <Layout>
        <Helmet>
          <title>Group Running Summary</title>
        </Helmet>

        <div className="contentBody">
          <div
            className={
              !this.props.headerHide
                ? `contentWrapper contentWrapperSmoothRelease report-modern-page asset-summary-report-page`
                : `contentWrapper contentWrapperSmooth report-modern-page asset-summary-report-page`
            }
          >
            <div className="reportHeaderTile">
              <div className="headingContainer report-modern-header">
                <div>
                  <h2 className="mainHeading">Group Summary</h2>
                  <p>Review running totals and asset activity across a selected group and date range.</p>
                  <div className="reportFilterNotice">Filtered trip logic is applied to these summary totals.</div>
                </div>
                <i
                  className={
                    this.props.headerHide
                      ? `fa fa-window-restore`
                      : `fa fa-window-maximize`
                  }
                  onClick={this.handleWindow}
                />
              </div>
              <div className="inputFormGroup reportPickerGrid reportPickerToolbar">
                <div className="inputElement reportPickerField">
                  <label>Group</label>
                  <Select
                    value={selectedGroupOption}
                    options={groupOptions}
                    styles={selectStyles}
                    onChange={(option) => {
                      if (option) {
                        this.handleGroupDropDown(option.value, option.data.groupName, option.data.customername);
                      } else {
                        this.setState({
                          groupId: "",
                          groupName: "",
                          customerName: "",
                          AssetList: [],
                          assetIdArray: [],
                          assetLoader: true,
                          assetSelectionBoolean: false,
                        });
                      }
                    }}
                    isClearable
                    isSearchable
                    placeholder="Search group"
                    noOptionsMessage={() => "No groups found"}
                  />
                </div>
                <div className="inputElement reportPickerField reportPickerDateField">
                  <label>Start Date</label>
                  <ReportButtonGroup
                    function={this.calendarFunction}
                    dropDown={calendarReport}
                    placeholder={this.state.dataPlaceholder}
                    icon="fa-calendar"
                  />
                </div>
                <div className="inputElement reportPickerField reportPickerDateField">
                  <label>End Date</label>
                  <ReportButtonGroup
                    function={this.calendarFunction2}
                    dropDown={calendarReport2}
                    placeholder={this.state.dataPlaceholder2}
                    icon="fa-calendar"
                  />
                </div>
                <div className="inputElement reportPickerActions">
                  <Button
                    className={hasPendingReportChanges ? "reportPickerCreateButton report-create-pending" : "reportPickerCreateButton"}
                    variant="primary"
                    onClick={this.handleCreateReport}
                    size="sm"
                    disabled={!canCreateReport}
                  >
                    <i className="fa fa-bar-chart"></i>
                    Create Report
                  </Button>
                </div>
              </div>
            </div>
            <TimeZoneConvert />
            {/* this.state.assetSelectionBoolean */}
            {this.state.assetSelectionBoolean ? (
              <div className="reportBody">
                {this.state.reportLoader ? (
                  <div className="loaderLine">
                    <br />{" "}
                    <GridLoader
                      size={7}
                      color={"#222222"}
                      loading={this.state.reportLoader}
                    />
                    <h1> &nbsp;Generating Report</h1>
                    <br />
                  </div>
                ) : this.state.errorLoader ? (
                  <div className="loaderLine">
                    <h1>Something Went Wrong...!</h1>
                  </div>
                ) : (
                  <React.Fragment>
                    {this.state.reportDetails != "" && (
                      <React.Fragment>
                        <GroupSummaryMetricTiles reportDetails={this.state.reportDetails} />
                        <TotalSummary reportDetails={this.state.reportDetails}
                        customerName = {this.state.customerName}
                        groupName = {this.state.groupName}
                        timeZone = {this.state.timeZone}
                         />
                      </React.Fragment>
                    )}
                    {/* {this.state.reportDetails != "" && (
                      <HourlyTotalSummary
                        reportDetails={this.state.reportDetails}
                        groupName = {this.state.groupName}
                        timeZone = {this.state.calendarStartDate}
                      />
                    )} */}
                  </React.Fragment>
                )}
              </div>
            ) : (
              <AssetInforWarning />
            )}
          </div>
        </div>
      </Layout>
    );
  }
}

const mapStateToProps = (state) => ({
  loading: state.loading,
  headerHide: state.headerHide,
  timeZoneId: state.timeZoneId,
});
const mapDispatchToProps = {
  setLoadingPageAction: setLoadingPage,
  setErrorMessageAction: setErrorMessage,
  setHeaderVisibleAction: setHeaderVisible,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(GroupRunningSummary);
